import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import tripLogo from "../../assets/img/tripLogo.png";
import { axiosReq, axiosReqCustom } from "../../commons/axiosReq";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from 'universal-cookie';
import VoiceIcon from "../../assets/icon/VoiceIcon";
import ActiveVoiceIcon from "../../assets/icon/ActiveVoiceIcon";
import { apiUrlVoiceSar } from "../../commons/inFormTypes";
import axios from "axios";
import SignatureWithModal from "../../components/MainAdmin/Modals/SignatureModal";
import { Link, useLocation } from "react-router-dom";
import { Textarea } from "@headlessui/react";

const questions۱ = [
  { text: "علاقه‌مند به طبیعت هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "علاقه‌مند به تاریخ هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "علاقه‌مند به شهرگردی هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "علاقه‌مند به اماکن مذهبی هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "علاقه‌مند به ماجراجویی هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "علاقه‌مند به ساحل هستم", options: ["1", "2", "3", "4", "5"] },
  { text: "بودجه من", options: ["کم", "متوسط", "زیاد"] },
  { text: "مدت سفر موردنظر", options: ["سفر یک‌روزه", "۲ روزه", "۳ تا ۵ روز", "۵ تا ۷ روز", "بیشتر از ۷ روز"] },
  { text: "فصل مورد علاقه برای سفر", options: ["بهار", "تابستان", "پاییز", "زمستان"] },
  { text: "دمای مطلوب مورد نظر", options: ["معتدل", "گرم", "سرد", "مرطوب", "خیلی گرم"] },
  { text: "وضعیت تأهل", options: ["تنها", "زوج", "خانوادگی"] }
];

const TripQuestions = () => {
  const [step, setStep] = useState(0);
  const [recommendations, setRecommendations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [snipper, setSnipper] = useState(false);
  // const [answers, setAnswers] = useState([]);

  const [data,
    setData] = useState([]);
  const [desc,
    setDesc] = useState();
  const [reCheck,
    setRecheck] = useState(false);

  const [questions, setQuestions] = useState([]);
  // const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [row, setRow] = useState(10);
  const itemsPerPage = 10;
  const [isStreaming, setIsStreaming] = useState(false);
  const audioChunksRef = useRef([]); // Stores recorded audio chunks
  const mediaRecorderRef = useRef(null); // MediaRecorder instance
  const [answers, setAnswers] = useState(Array(questions.length).fill(null));
  const [showSigModal, setShowSigModal] = useState(false);
  const [img, setImg] = useState(null);

  const [messages,
    setMessages] = useState([
      {
        text: "سلام! آماده‌ام تا مقصد مناسب سفر رو برات پیدا کنم 😊",
        sender: "bot"
      }
    ]);
  const navigate = useNavigate();

  const location = useLocation();

  const GetData = async () => {
    setIsLoading(true)
    const writersData = await axiosReq("exam/GetQuestionsByExam?page=" + page + "&&pageSize=" + row + "&&search=" + search, "post", {
      ExamId: location?.state?.examId,

    });
    console.log(writersData)
    // setWritersList(writersData?.data)
    // setCount(writersData?.count)
    setQuestions(writersData?.data)
    setCount(writersData?.count)
    setIsLoading(false)

  }
  const auth = async () => {
    const cookies = new Cookies();
    var token = cookies.get('token');
    console.log(token)
    console.log(cookies.get('role'))
    if (!token) {
      navigate("/");
    }
    else {
      //     if( cookies.get('role')=="Admin")
      //    {

      GetData()
      //    }


      //     else {
      //         navigate("/admin");

      //     }
    }
  }
  useEffect(() => {

    auth();
  }, [reCheck, search, page, row,]);


  const handleSelect = (value) => {
    const updated = [...answers];
    updated[step] = value;
    setAnswers(updated);
    console.log(step)
    if (step < questions.length - 1) {
      setStep(step + 1);
    } else {
      console.log("پاسخ‌ها:", updated);
      navigate("/tripChat", { state: { answers: updated } });

    }
  };

  const goBack = () => {
    if (step > 0) setStep(step - 1);
  };
  const handleSubmit = async (val) => {
    setIsLoading(true); // 👈 شروع لودینگ
    // const updated = [...answers];
    // updated[step] = value;
    // setAnswers(updated);

    try {

      console.log(666)
      console.log(val)
      var que = []


      setShowSigModal(false)
      answers.map((item, index) => {
        que.push({
          ExamQuestionId: questions[index].examQuestionId,
          Answer: item,
          ExamUserId: location.state.examUserId
        })
      })

      const dataUser = await axiosReq("exam/InsertExamUserQuestionGroup", "post", {
        Questions: que,
        Signature: val
      });

      if (dataUser.status == 200) {
        setData((prev) => [...prev, dataUser?.data]);
        setRecheck(!reCheck);
        alert("با موفقیت اضافه شد.")
        navigate('/mainAdmin/UserExam', {
          // state: {
          //   answers: updated,
          //   recommendations: recommendations,
          // }
        });
      }


    } catch (error) {
      console.error("خطا در ارسال:", error);
    } finally {
      setIsLoading(false);
    }

  };
  const next = () => {
    console.log(questions.length)
    console.log(step)
    if (step + 1 < questions.length) {
      setStep(step + 1)
    }
    else {
      setShowSigModal(true)
    }

  }

  ////

  const toggleStreaming = async () => {
    if (isStreaming) {
      // Stop recording and WebSocket connection
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
        setIsStreaming(false);
        console.log("Streaming stopped.");
      }
      //if (websocketRef.current) {
      //    websocketRef.current.close();
      //}
      setIsStreaming(false);
      console.log("Streaming stopped.");
    } else {
      // Start recording and WebSocket connection
      try {
        setSnipper(true)
        setIsStreaming(true);




        // Request microphone access
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        mediaRecorderRef.current = recorder;
        setSnipper(false)

        // Capture audio data chunks
        recorder.ondataavailable = (e) => {
          audioChunksRef.current.push(e.data);
        };

        // When recording stops, save audio and send file path to server
        recorder.onstop = async () => {
          const blob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
          audioChunksRef.current = []; // Clear chunks after saving
          console.log(7777)
          // Save the audio file locally and send its path to the server
          const fileurl = await CreateUrl(blob, "audio.mp3");
          console.log("Audio saved at:", fileurl);

          // if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
          //     websocketRef.current.send(JSON.stringify({ file_url: fileurl }));
          //     console.log("Sent audio file path to the server.");
          // }
        };

        // Start recording
        recorder.start();
        console.log("Audio recording started.");
      } catch (error) {
        console.error("Error starting streaming:", error);
      }
    }
  };

  const CreateUrl = async (blob, fileName) => {
    try {
      const file = new File([blob], fileName, { type: "audio/mp3" });
      console.log(222)
      console.log(file)
      // const formData = new FormData();
      // formData.append("FileDetails", file)
      // Create a downloadable link for the file
      // const link = document.createElement("a");
      // link.href = URL.createObjectURL(file);
      // link.download = fileName;
      // link.click();


      const formData = new FormData();
      // "file" must match your curl field name: -F 'file=@test.txt;type=text/plain'
      formData.append("file", file);

      const { data, status } = await axios.post(
        apiUrlVoiceSar + "transcribe?language=fa",
        formData,
        {
          headers: {
                                    Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,

            // Let the browser set the multipart boundary
            Accept: "application/json",
          },
        }
      );

      if (status >= 200 && status < 300) {
        console.log(444)
        console.log(data)
        const updated = [...answers];
        updated[step] = data?.result;
        setAnswers(updated);
      }
      else {
        setSnipper(false);

        // setEroor(data || "خطا در پردازش فایل");
        // setShowErrorModalStep1(true);
      }
    }
    catch (err) {
      setSnipper(false);

      console.log(
        err?.response?.data?.message ||
        err?.message ||
        "خطا در برقراری ارتباط با سرور"
      );
      // setShowErrorModalStep1(true);
    } finally {
      setSnipper(false);
    }
  };





  return (
    <div className="h-screen flex  flex-col justify-center items-center bg-gray-100 tripBackgroud">
      <div className="flex items-center mb-2">
        {/* <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2" /> */}
        <span className="font-Beiruti text-[#265069] text-[20px]">
          سوالات گزینشی
        </span>
      </div>
      <div className="bg-white h-auto  rounded-3xl shadow-lg p-8 md:p-4 w-full max-w-xl">

        {isLoading ? (
          <div className="flex flex-col justify-center items-center h-[300px]">
            <ClipLoader size={40} color="#0b94ca" />
            <p className="mt-4 font-IRANYekanMedium text-[#0b94ca] text-[14px]">
              در حال پردازش اطلاعات...
            </p>
          </div>
        ) : (
          <div className="justify-between">
        

            <h2 className="text-lg text-[18px] font-IRANYekanExtra text-gray-700  text-center">
              سؤال {step + 1} از {questions.length}
            </h2>

            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${((step + 1) / questions.length) * 100}%` }}
              ></div>
            </div>

            <p className="text-[15px] text-gray-800 mb-8 text-center font-IRANYekanBold">
              {questions[step]?.question.title}
            </p>


   <p className="text-[12px] text-gray-800 mb-8 text-center font-IRANYekanMedium">
              برای پاسخ باصوت، بر روی آیکون میکروفون کلیک کرده و بعد از پاسخ دوباره کلیک نمایید.
            </p>
            {/* <div className="flex justify-center gap-4 mb-6 flex-wrap">
        {questions[step].options.map((option, index) => (
          <button
            key={index}
            onClick={() => step === 10 ? handleSubmit(option) : handleSelect(option)}
            className={`min-w-[45px] w-auto px-2 h-[45px] rounded-full text-sm font-semibold font-IRANYekanBold
              border-2 transition
              ${answers[step] === option 
                ? "bg-[#0b94ca] text-white border-blue-500" 
                : "bg-[#d8e5ed] text-blue-600 border-[#0b94ca] hover:bg-blue-500 hover:text-white"}`}>
            {option}
          </button>
        ))}
      </div> */}
            <div className="flex justify-center gap-4 mb-6 flex-wrap">
              {isStreaming ?
                <button className="flex justify-end" onClick={toggleStreaming}>
                  <ActiveVoiceIcon width={"40px"} height={"40px"}/>
                                            <p className="text-[20px] font-IRANYekanBold mb-1">درحال ضبط</p>

                </button>

                :
                <button className="flex justify-end" onClick={toggleStreaming}>
                  <VoiceIcon width={"40px"} height={"40px"}/>
                </button>
              }
            </div>
            {/* {
    answers[step]? */}

            <div className=" w-full mt-[23px] mb-[43px]">
              <div className="col-span-1 mb-[10px] flex flex-col">
                <span className="text-[15px] font-IRANYekanBold mb-1">پاسخ</span>
                <textarea
                  key={step} // Forces rerender when step changes
                  onChange={(e) => {
                    setAnswers(prev => {
                      const updated = [...prev];
                      updated[step] = e.target.value;
                      return updated;
                    });
                  }}
                  name="answer"
                  placeholder="پاسخ را اینجا بنویسید"
                  value={answers[step] ?? ""}
                  maxLength={2000}
                  className="h-[100px] focus:outline-lightGray border-[1px] border-borderGray
             text-[15px] font-IRANYekanNormal pr-[10px] rounded-[5px]
             placeholder-lightGray"
                  type="text"
                />

                {
                  answers[step]?.length == 0 ?
                    <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                      لطفا پاسخ را وارد نمایید !
                    </span>
                    :
                    null
                }
              </div>
            </div>
            {/* :
null} */}




            <div className="flex justify-between items-center mt-24">
            
              <button
                onClick={goBack}
                disabled={step === 0}
                className="text-sm font-IRANYekanBold text-gray-600 px-4 py-2 rounded hover:text-blue-600 disabled:opacity-50"
              >
                 سؤال قبلی
              </button>
                <button
                onClick={() => next()}
                // disabled={step+1 === questions.length}
                className="text-sm font-IRANYekanBold text-gray-600 px-4 py-2 rounded hover:text-blue-600 disabled:opacity-50"
              >
                {step + 1 < questions.length ?
                  <p>  سؤال بعدی</p>
                  :
                  <p>پایان</p>}
              </button>
            </div>
          </div>
        )}
      </div>
      {showSigModal ? <SignatureWithModal isOpen={showSigModal} onClose={setShowSigModal} setImg={setImg} handleSubmit={handleSubmit} /> : null}

    </div>
  );
};

export default TripQuestions;
